export enum NumberConversionStatus {
  ambiguous = 'Ambiguous',
  converted = 'Converted'
}